import { Dialog } from "@fronterahealth/frontera-ui-components";

import { Loader } from "@components/ClinicalNewReportDialog/Loader";

interface ConfirmationDialogProps {
  onSubmitClick: () => void;
  onCancelClick: () => void;
  open: boolean;
  title: string;
  content: string;
  cancelButtonText?: string | React.ReactNode;
  submitButtonText?: string | React.ReactNode;
  submitButtonLoading?: boolean;
  tertiaryButtonText?: string | React.ReactNode;
  onTertiaryClick?: () => void;
  submitButtonAction?: "destructive" | "regular";
  cancelButtonAction?: "destructive" | "regular";
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  onSubmitClick,
  onCancelClick,
  open,
  title,
  content,
  cancelButtonText,
  submitButtonText,
  submitButtonLoading,
  tertiaryButtonText,
  onTertiaryClick,
  cancelButtonAction,
  submitButtonAction,
}) => {
  return (
    <Dialog
      size="xl"
      showCloseButton={false}
      title={title}
      open={open}
      setOpen={() => {}}
      primaryButton={{
        text: (
          <>
            {submitButtonLoading && <Loader className="h-4 w-4" />} {submitButtonText ?? "Yes, Submit"}
          </>
        ),
        disabled: submitButtonLoading,
        onClick: onSubmitClick,
        type: "submit",
        buttonAction: submitButtonAction ?? "destructive",
      }}
      secondaryButton={{
        text: cancelButtonText ?? "No, Cancel",
        disabled: !!submitButtonLoading,
        onClick: onCancelClick,
        buttonAction: cancelButtonAction ?? "regular",
      }}
      {...(tertiaryButtonText != null &&
        onTertiaryClick != null && {
          tertiaryButton: {
            text: tertiaryButtonText,
            disabled: !!submitButtonLoading,
            onClick: onTertiaryClick,
          },
        })}
    >
      <div className="py-2 text-text-primary text-base">{content}</div>
    </Dialog>
  );
};
